// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3vxsV","bigColWidth":"Table_bigColWidth__lnwTK","biggerColWidth":"Table_biggerColWidth__2MHUb","row":"Table_row__SE_1D","col":"Table_col__2r5vC"};